import { render, staticRenderFns } from "./HostingMeta.vue?vue&type=template&id=16c8cf7e&"
import script from "./HostingMeta.vue?vue&type=script&lang=js&"
export * from "./HostingMeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../partner/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports